import { WalletClient, TokenId } from "@martiandao/aptos-web3-bip44.js";

import { foil_vesting_address } from "./address";
const NODE_URL = process.env.REACT_APP_APTOS_NODE_URL!;
const FAUCET_URL = process.env.REACT_APP_FAUCET_URL!;
const _client = new WalletClient(NODE_URL, FAUCET_URL);
export interface TokenData {
  data: TokenId;
  deposit_sequence_number: string;
  withdraw_sequence_number: string;
  difference: number;
}

export interface TokenIds {
  tokenIds: TokenData[];
  maxDepositSequenceNumber: number;
  maxWithdrawSequenceNumber: number;
}

export const getFoilNFTs = async (address: string): Promise<TokenId[]> => {
  const tokenIds: TokenIds = await _client.getTokenIds(address);
  if (!tokenIds || tokenIds.tokenIds.length === 0) return [];
  const token_ids: TokenData[] = tokenIds.tokenIds;
  const token_foil_ids: TokenId[] = [];
  for (let i = 0; i < token_ids.length; i++) {
    const token_id = token_ids[i];
    if (token_id.difference !== 1) continue;
    if (
      token_id.data.token_data_id.creator === foil_vesting_address &&
      token_id.data.token_data_id.collection === "Foil NFT"
    ) {
      token_foil_ids.push(token_id.data);
    }
  }
  return token_foil_ids;
};
export const getLockedBalance = async (token_id: number) => {
  const tableItemRequest = {
    key_type: "u64",
    value_type: `${foil_vesting_address}::foil::LockedBalance`,
    key: token_id.toString(10),
  };
  const resources = await _client.aptosClient.getAccountResources(
    foil_vesting_address
  );
  const accountResource = resources.find(
    (r) => r.type === `${foil_vesting_address}::foil::VotingEscrowInfo`
  );
  //@ts-ignore
  const handle = accountResource!.data.locked_map.handle;
  const locked_balance = await _client.aptosClient.getTableItem(
    handle,
    tableItemRequest
  );
  return locked_balance;
};
export const getVestValue = async (token_id: number): Promise<number> => {
  const payload = {
    function: `${foil_vesting_address}::foil::balance_of_nft`,
    type_arguments: [],
    arguments: [token_id.toString(10)],
  };
  const res = await _client.aptosClient.view(payload);
  return parseInt(res[0] as string, 10);
};
